import React, { useEffect, useState } from 'react';
import { FaWhatsapp } from "react-icons/fa";
import { IoIosArrowUp } from "react-icons/io";
import "animate.css";
import { IoMdClose } from "react-icons/io";
import "./fixedbutton.css";
function FixedButtons() {
    const [isVisible, setIsVisible] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);



    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const handleOpenModal = () => {
        setOpenModal(!openModal);
    }

    const openWhatsApp = () => {
        const whatsappURL = "https://api.whatsapp.com/send/?phone=918530030700&text&type=phone_number&app_absent=0";
        window.open(whatsappURL, "_blank");
    }

    const currentTime = new Date();
    const formattedTime = `${currentTime.getHours()}:${currentTime
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;

    return (
        <>
            {
                isVisible && (
                    <>
                        <button
                            className="position-fixed text-white p-3 "
                            style={{
                                left: 20,
                                backgroundColor: "#d12420",
                                bottom: 20,
                                zIndex: 100,
                                borderRadius: '50%',
                                border: '2px solid white',
                                width: '60px',
                                height: '60px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                cursor: 'pointer',
                                transition: 'transform 0.3s ease, background-color 0.3s ease',
                            }}
                            onClick={handleOpenModal}

                        >
                            <FaWhatsapp size={25} />
                        </button>
                        {openModal && (
                            <div
                                className="whatsapp-popup"
                                style={{
                                    position: "fixed",
                                    bottom: "90px",
                                    left: "20px",
                                    width: "290px",
                                    height: "260px",
                                    backgroundColor: "#f0f0f0",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                    overflow: "hidden",
                                    zIndex: 100,
                                }}
                            >
                                {/* Header */}
                             
                                <div
                                    style={{
                                        backgroundColor: "#008069", 
                                        padding: "10px 15px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        color: "#fff",
                                        borderTopLeftRadius: "10px",
                                        borderTopRightRadius: "10px",
                                    }}
                                >
                                    
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <img
                                            src="/logo-theme.png"
                                            alt="Profile"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                border: "2px solid #fff",
                                            }}
                                        />
                                        <div>
                                            <h5
                                                style={{
                                                    margin: 0,
                                                    fontSize: "16px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                              CSM Patsanstha
                                            </h5>
                                            <span
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#D9FDD3", 
                                                }}
                                            >
                                                Online
                                            </span>
                                        </div>
                                    </div>

                                    {/* Close Icon */}
                                    <IoMdClose
                                        size={24}
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        onClick={() => setOpenModal(false)}
                                    />
                                </div>
                                {/* Chat Content */}
                                <p className='text-center mt-2 opacity-50'>{formattedTime}</p>
                                <div
                                    style={{
                                        padding: "10px 15px",
                                        backgroundColor: "#f0f0f0",
                                        fontSize: "14px",
                                        lineHeight: "20px",

                                    }}
                                    className='d-flex justify-content-center chat-section'
                                >
                                    <div
                                        style={{
                                            backgroundColor: "#fff",
                                            padding: "15px",
                                            borderRadius: "8px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            marginBottom: "10px",
                                            width: "100%"
                                        }}
                                    >
                                        Hi there 👋 <br />
                                        How can I help you?
                                    </div>
                                    <button
                                        onClick={openWhatsApp}

                                        style={{
                                            backgroundColor: "#25D366",
                                            color: "#fff",
                                            padding: "15px 25px",
                                            border: "none",
                                            borderRadius: "20px",
                                            fontSize: "16px",
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: "100px",
                                        }}

                                    >
                                        <FaWhatsapp style={{ marginRight: "5px" }} />
                                        Chat on WhatsApp
                                    </button>
                                </div>
                            </div>
                        )}

                        <button
                            className="position-fixed text-white p-3 "
                            style={{
                                right: 20,
                                bottom: 20,
                                zIndex: 100,
                                backgroundColor: "#d12420",
                                borderRadius: '50%',
                                border: '2px solid white',
                                width: '60px',
                                height: '60px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                cursor: 'pointer',
                                transition: 'transform 0.3s ease, background-color 0.3s ease',
                            }}
                            onClick={scrollToTop}
                        >
                            <IoIosArrowUp size={25} />
                        </button>
                    </>
                )
            }

        </>
    );
}

export default FixedButtons;
